import { Button } from '@/components/ui/button';
import { getLabelValue } from '@/utils/getLabelValue';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAttendeeStats } from '../api/get-attendee-stats';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Card, CardContent } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { CheckpointEnteriesTable } from '../components/checkpoint-enteries-table';

export function AttendeeDetails() {
  const [searchParams] = useSearchParams();

  const badgeNo = searchParams.get('badgeNo');
  const navigate = useNavigate();

  const attendeStatsQuery = badgeNo
    ? useAttendeeStats({
        badgeNo,
        config: {
          enabled: !!badgeNo,
        },
      })
    : null;

  if (!badgeNo) {
    return (
      <div className="flex flex-col text-muted-foreground items-center justify-center h-full">
        {getLabelValue('NoValidBadgeNo')}
        <Button variant="link" onClick={() => navigate(-1)} className="flex gap-2 underline">
          {getLabelValue('ReturnMessage')}
        </Button>
      </div>
    );
  }

  if (!attendeStatsQuery?.data) {
    return <div>No data found</div>;
  }

  return (
    <div className="w-full h-[calc(100svh_-_60px)] space-y-2 p-2">
      {attendeStatsQuery.isLoading && (
        <div className="flex justify-center h-full items-center">
          <Loader2 className="h-8 w-8 animate-spin" />
        </div>
      )}
      <div onClick={() => navigate(-1)} className="flex gap-2">
        <ArrowLeft /> {getLabelValue('Back')}
      </div>
      <div className="flex flex-col gap-4">
        <Card>
          <CardContent className="flex gap-4 p-2 justify-between">
            <div className="flex flex-col gap-2 p-2">
              <Label>{getLabelValue('Name')}</Label>
              <p className="text-[14px]">{attendeStatsQuery.data?.fullName}</p>
            </div>
            <div className="flex flex-col gap-2 p-2">
              <Label>{getLabelValue('CompanyName')}</Label>
              {attendeStatsQuery.data?.companyName}
            </div>
          </CardContent>
        </Card>
        <Tabs defaultValue="bookings">
          <TabsList>
            <TabsTrigger value="bookings">{getLabelValue('Bookings')}</TabsTrigger>
            <TabsTrigger value="onsite-enteries">{getLabelValue('OnsiteEnteries')}</TabsTrigger>
          </TabsList>
          <TabsContent value="bookings" className="flex flex-col gap-4">
            <Card>
              <CardContent className="flex flex-col gap-2 p-4">
                {attendeStatsQuery.data.bookings?.map((booking, index) => (
                  <div key={index} className="border-b-2 pb-2">
                    <p className="truncate">{booking.eventName}</p>
                  </div>
                ))}
              </CardContent>
            </Card>
          </TabsContent>
          <TabsContent value="onsite-enteries">
            <CheckpointEnteriesTable checkpointEnteries={attendeStatsQuery.data.checkpointEntries} />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
